import styled from '@emotion/styled';
/* Visually hides element but still provide it for screen readers */
/* https://a11yproject.com/posts/how-to-hide-content/ */
export var visuallyHidden = "\n  position: absolute !important;\n  height: 1px;\n  width: 1px;\n  overflow: hidden;\n  clip: rect(1px, 1px, 1px, 1px);\n";
export var Invisible = styled.div(function () { return visuallyHidden; });
//# sourceMappingURL=visuallyHidden.js.map